'use strict';

angular.module('internal.vehicles')
    .controller('InternalVehicleInvestigations', ['$scope', 'Complaints', function ($scope, Complaints) {
        $scope.resetVehicle();
        $scope.vm = {
            bulkActionItems: [],
            bulkActionRunning: false
        }

        $scope.setStatus = function (bulkApply, status) {
            if (status != null && $scope.vm.bulkActionItems.length > 0) {
                $scope.vm.bulkActionRunning = true;
                Complaints.bulkAction($scope.vm.bulkActionItems, status, 'status').then(function () {
                    bulkApply.isOpen = false;
                    $scope.getVehicle();
                    $scope.vm.bulkActionItems.length = 0;
                    $scope.vm.bulkActionRunning = false;
                    window.location.reload();
                })
            }
        }

        $scope.bulkActions = [
            {
                action: $scope.setStatus,
                service: 'ComplaintStatuses'
            }
        ]
    }])
;